window.$mm_schedule_result = [];
window.$mm_schedule_treeChangeStatus = false;
window.$mm_schedule_page_number = 1;
window.$mm_schedule_Glist = [];
window.$mm_schedule_selectedRow = "";
window.$mm_schedule_content = [];
window.$mm_schedule_lastUsedTableFilter = [];
window.$mm_schedule_scroll_change = false;
window.$mm_schedule_filterContent = [];
window.$mm_schedule_filterClickStatus = false;
window.$mm_schedule_filterLastIds = [];
window.$mm_schedule_searchInputId = null;
window.$mm_schedule_columnList = [];
window.$mm_schedule_plannigAlgemeenGisratio = [];
window.$mm_schedule_plannigStatus = [];
window.$mm_schedule_maatregelNaam = [];
window.$mm_schedule_werkplanNaam = [];
window.$mm_schedule_planningspatroonNaam = [];
window.$mm_schedule_planningsperiodeNaam = [];
window.$mm_schedule_budgetNaam = [];
window.$mm_schedule_beheereenheidNaam = [];
window.$mm_schedule_beheeractiviteitLaag = [];
window.$mm_schedule_disciplineNaam = [];
window.$mm_schedule_statusTijdstipVerzonden = [];
window.$mm_schedule_filterCheckControlGPlannig = [false, false, false];
window.$mm_schedule_gvv = 1;
window.$mm_schedule_last_search_id = "";
window.$mm_schedule_table_total_row_count = 0;
window.$mm_schedule_isOpen = false;
window.$mm_schedule_bulkUpdateDetailOnClose = function (){};
window.$mm_schedule_tableReload = function (){};
window.$mm_schedule_context = null;
window.$mm_schedule_bulkUpdateEditContext = null;
window.$mm_schedule_ws = null;
window.$mm_schedule_settings_list = null;
window.$mm_schedule_columnListPure = null;
window.$mm_schedule_filterCheckControl = [
  ["status-detailplanning", false, false],
  ["status-budget", false, false],
  ["status-uitvoering", false, false],
  ["status-werkplan", false, false],
  ["planning-iscorrectiefonderhoud", false, false],
  ["status-verzonden", false, false],
  ["status-statuslaatstechecknatuurbescherming", false, false, false],
];
window.$mm_schedule_filterClickControl = [
  ["status-detailplanning", false],
  ["status-budget", false],
  ["status-uitvoering", false],
  ["status-werkplan", false],
  ["planning-iscorrectiefonderhoud", false],
  ["status-verzonden", false],
  ["status-statuslaatstechecknatuurbescherming", false],
];

window.$mm_schedule_actions = [
  {
    id: "57d136a2-9749-46d4-85c4-edda4de75409",
    text: "Plaats in budget",
    class: "locate",
    modal: "plaats_in_budget",
  },
  {
    id: "PLAATS_IN_WERKPLAN",
    text: "Plaats in werkplan",
    class: "locate",
    modal: "plaats_in_werkplan",
  },
  {
    id: "WIJZIG_STATUS",
    text: "Wijzig status",
    class: "locate",
    modal: "wijzig_status",
  },
  {
    id: "PLAATS_IN_UITVOERING",
    text: "Plaats in uitvoering",
    class: "locate",
    modal: "plaats_in_uitvoering",
  },
  {
    //id: "plannig_natuurbeschermingscheck",
    id: "PLAATS_IN_DETAILPLANNING",
    text: "Plaats in detailplanning",
    class: "locate",
    modal: "plaats_in_detailplanning",
  },
  {
    id: "plannig_natuurbeschermingscheck",
    text: "Plaats in detailplanning",
    class: "locate",
    modal: "plannig_natuurbeschermingscheck_modal",
  },
  {
    id: "bulk_update",
    text: "Weer je kan",
    class: "locate",
    modal: "bulk_update_modal",
  },
  {
    id: "plannig_toon_op_kaart",
    text: "plannig_toon_op_kaart",
    class: "locate",
    modal: "",
  },
];

/* window.$mm_schedule_actions = [
  {
    id: "57d136a2-9749-46d4-85c4-edda4de75409",
    text: "Plaats in budget",
    class: "locate",
    modal: "plaats_in_budget",
  },
  {
    id: "1041f11d-46f4-4a46-a1c5-8e6d91f0877f",
    text: "Plaats in werkplan",
    class: "locate",
    modal: "plaats_in_werkplan",
  },
  {
    id: "3a98846b-67c1-4192-9edc-b980f10898b8",
    text: "Wijzig status",
    class: "locate",
    modal: "wijzig_status",
  },
  {
    id: "56785c54-8059-46ae-8b7f-250ce971a539",
    text: "Plaats in uitvoering",
    class: "locate",
    modal: "plaats_in_uitvoering",
  },
  {
    //id: "plannig_natuurbeschermingscheck",
    id: "17a25835-e4f8-4189-bcaa-30b7194c7c2b",
    text: "Plaats in detailplanning",
    class: "locate",
    modal: "plaats_in_detailplanning",
  },
  {
    id: "plannig_natuurbeschermingscheck",
    text: "Plaats in detailplanning",
    class: "locate",
    modal: "plannig_natuurbeschermingscheck_modal",
  },
  {
    id: "bulk_update",
    text: "Weer je kan",
    class: "locate",
    modal: "bulk_update_modal",
  },
]; */

window.$cmm_schedule_column_order_post_model = {
  client_identification: "",
  code: "",
  data: {
    table_sorting: [
      {
        name: "management-maintenance>schedule",
        column_list: [
          "checkbox",
          "active",
          "status_laatste_check_natuurbescherming",
          "status_detailplanning",
          "status_budget",
          "status_uitvoering",
          "status_werkplan",
          "planning_iscorrectiefonderhoud",
          "status_verzonden",
          "Gisratio Id",
          "Status",
          "Maatregel",
          "Werkplan",
          "Planningspatroon",
          "Planningsperiode",
          "Budget",
          "Beheereenheid",
          "Laag",
          "Discipline",
          "Tijdstip verzonden",
          "Startdatum Planningsperiode",
        ],
      },
    ],
  },
};
